module.exports = __webpack_public_path__ + "img/mp4.525abbc7.svg";